import axios from 'axios'
import { paymentTypeUrl, getHeader } from '../config'

const state = {
  paymentTypeList: []
}

const mutations = {
  SET_PAYMENT_TYPE_LIST (state, obj) {
    state.paymentTypeList = obj
  }
}

const actions = {
  getPaymentTypeList: ({ commit }) => {
    axios.get(paymentTypeUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PAYMENT_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
